import React, { useMemo } from "react"
import { Box, Text } from "@chakra-ui/react"
import { Form } from "sharedTypes"
import { MERGE_TAGS, NAME_FIELD_TAGS } from "utilities/enums"
import { PillShell } from "components/TemplateEditor/VariablePill"

type Props = {
  body?: string | null
  forms?: Form[]
}

const getFormLabel = (formId: string, forms: Form[]): string => {
  const form = forms.find((f) => f.externalId === formId)

  return form ? `Form Link: ${form.name}` : "Form Link"
}

const MessageBubbleContent = ({ body, forms = [] }: Props) => {
  const segments = useMemo(() => {
    const text = body ?? ""
    const result: React.ReactNode[] = []
    const regex = /\{\{(\w+)\}\}/g
    let lastIndex = 0
    let match = regex.exec(text)

    while (match !== null) {
      if (match.index > lastIndex) {
        result.push(
          <Text as="span" key={`t-${lastIndex}`}>{text.slice(lastIndex, match.index)}</Text>,
        )
      }

      const tagId = match[1]
      const formMatch = tagId.match(/^FORM_(.+)$/)

      if (formMatch) {
        const label = getFormLabel(formMatch[1], forms)
        result.push(
          <PillShell key={`v-${match.index}`} variant="selectable" size="md">
            <Text>{label}</Text>
          </PillShell>,
        )
      } else {
        const mergeTag = MERGE_TAGS.find((t) => t.id === tagId)
        if (mergeTag) {
          const isNameField = NAME_FIELD_TAGS.includes(tagId)
          result.push(
            <PillShell key={`v-${match.index}`} variant={isNameField ? "selectable" : "locked"} size="md">
              <Text>{mergeTag.label}</Text>
            </PillShell>,
          )
        } else {
          result.push(<Text as="span" key={`v-${match.index}`}>{match[0]}</Text>)
        }
      }

      lastIndex = match.index + match[0].length
      match = regex.exec(text)
    }

    if (lastIndex < text.length) {
      result.push(<Text as="span" key={`t-${lastIndex}`}>{text.slice(lastIndex)}</Text>)
    }

    return result
  }, [body, forms])

  return (
    <Box whiteSpace="pre-wrap" lineHeight={1.75}>
      {segments}
    </Box>
  )
}

export default MessageBubbleContent
